const StudentRanksReducers = (state = [], action) => {
    switch (action.type) {
        case "STUDENT_RANKS_LOADING":
            return {
                studentRanks: [],
                isLoaded: false
            };
        case "STUDENT_RANKS_INITIAL":
            return {
                studentRanks: action.studentRanks,
                isLoaded: true
            };
        default:
            return state;
    }
}

export default StudentRanksReducers;